import { Direction_Enum } from '@weave/schema-gen-ts/dist/schemas/fax/shared/v1/enums.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, SkeletonLoader } from '@frontend/design-system';

type ContactTextProps = {
  name: string;
  direction: Direction_Enum;
  loading?: boolean;
};

export const ContactText = ({ name, direction, loading = false }: ContactTextProps) => {
  const { t } = useTranslation('fax');

  if (loading) {
    return <SkeletonLoader height={14} width='60%' />;
  }

  if (name) {
    return (
      <Text size='medium' css={{ color: theme.colors.neutral80 }}>
        {direction === Direction_Enum.INBOUND
          ? t('From {{sender}}', { sender: name.trim() })
          : t('To {{recipient}}', { recipient: name.trim() })}
      </Text>
    );
  }
  return null;
};
